import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

function RestaurantActionsPage() {
  const { restaurantId } = useParams();
  const [unsubscribeLink, setUnsubscribeLink] = useState('');

  // useEffect(() => {
  //   // Generate the unsubscribe link based on the restaurant ID
  //   const link = `${process.env.REACT_APP_BASE_URL}/unsubscribe/${restaurantId}`;
  //   setUnsubscribeLink(link);
  // }, [restaurantId]);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(unsubscribeLink);
    toast.success('Unsubscribe link copied to clipboard!');
  };

  return (
    <div className='flex'>
      <nav className='w-64 bg-gray-200 p-6'>
        <ul>
          <li className='mb-4'>
            <Link
              to={`/restaurant/${restaurantId}/actions`}
              className='text-blue-500'
            >
              Restaurant Actions
            </Link>
          </li>
          <div className='unsubscribe-link-section'>
            <h3>Unsubscribe Link</h3>
            <p>
              Copy and share this link with your customers to allow them to
              unsubscribe:
            </p>
            <div className='unsubscribe-link-container'>
              <input
                type='text'
                value={unsubscribeLink}
                readOnly
                className='flex-1 p-2 border border-gray-300 rounded mr-2'
              />
              <button
                onClick={handleCopyLink}
                className='px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600'
              >
                Copy Link
              </button>
            </div>
          </div>
          <li className='mb-4'>
            <Link
              to={`/restaurant/${restaurantId}/subscribers`}
              className='text-blue-500'
            >
              Subscribers
            </Link>
          </li>
          <li className='mb-4'>
            <Link
              to={`/restaurant/${restaurantId}/messages`}
              className='text-blue-500'
            >
              Text Messages
            </Link>
          </li>
          <li className='mb-4'>
            <Link
              to={`/restaurant/${restaurantId}/qr-code`}
              className='text-blue-500'
            >
              QR Code
            </Link>
          </li>
          <li className='mb-4'>
            <Link
              to={`/restaurant/${restaurantId}/welcome-text`}
              className='text-blue-500'
            >
              Welcome Text
            </Link>
          </li>
          <li className='mb-4'>
            <Link
              to={`/restaurant/${restaurantId}/membership`}
              className='text-blue-500'
            >
              Membership
            </Link>
          </li>
        </ul>
      </nav>
      <div className='flex-1 p-6'>
        <h1 className='text-3xl font-bold mb-6'>Restaurant Actions</h1>
        <p>Select an action from the left menu to manage your restaurant.</p>
      </div>
    </div>
  );
}

export default RestaurantActionsPage;
